// Vehicle Details
export const GET_VEHICLE_DETAILS = 'GET_VEHICLE_DETAILS';
export const GET_RECALL_STATUS = 'GET_RECALL_STATUS';
export const GET_TRANSIT_CHARGE = 'GET_TRANSIT_CHARGE';
export const GET_TRANSIT_ROUTE = 'GET_TRANSIT_ROUTE';
export const GET_DELIVERY_PICKUP_DATA = 'GET_DELIVERY_PICKUP_DATA';
export const GET_HAS_OWNER_REVIEWS = 'GET_HAS_REVIEWS';
export const REMOVE_SOONEST_DELIVERY = 'REMOVE_SOONEST_DELIVERY';
export const SET_ANALYTICS_EVENT_IDS = 'SET_ANALYTICS_EVENT_IDS';

// Experiments
export const ADD_EXPERIMENT = 'ADD_EXPERIMENT';
export const SET_EXPERIMENTS_LOADED = 'SET_EXPERIMENTS_LOADED';

// FAVORITES
export const SET_CURRENT_VEHICLE_FAVORITED = 'SET_CURRENT_VEHICLE_FAVORITED';

// USER
export const GET_USER_AVAILABILITY = 'GET_USER_AVAILABILITY';
export const GET_USER_PURCHASING = 'GET_USER_PURCHASING';
export const GET_USER_FINANCING = 'GET_USER_FINANCING';

// SPINNER
export const SET_SPINNER_SCRIPT_INSERTED = 'SET_SPINNER_SCRIPT_INSERTED';
export const SET_SPINNER_IMMERSIVE = 'SET_SPINNER_IMMERSIVE';
export const SET_SPINNER_TOUR_MODE = 'SET_SPINNER_TOUR_MODE';
export const SET_SPINNER_TYPE = 'SET_SPINNER_TYPE';
export const SPINNER_FAILED_LOADING = 'SPINNER_FAILED_LOADING';

// Router
export const SET_HASH = 'SET_HASH';
